import { responsive, useBreakPoints, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { getContainerStyles } from '@/utils';

export const useStyles = () => {
  const { theme } = useTheme();

  const { isTablet, isDesktop } = useBreakPoints();

  return useMemo(
    () => ({
      wrapper: css`
        width: 100%;
        overflow: hidden;
      `,
      container: css`
        ${getContainerStyles(theme)};
        ${responsive.create({
          paddingTop: {
            default: theme.spacing.get(56),
            md: theme.spacing.get(72),
            lg: theme.spacing.get(100),
          },
          paddingBottom: {
            default: theme.spacing.get(396),
            md: theme.spacing.get(56),
            lg: theme.spacing.get(80),
          },
        })}
      `,

      title: css`
        font-weight: ${theme.fonts.weight.medium};
        text-align: center;
        color: ${theme.colors.commonColors.white};
        color: var(--text-color);
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xl}`,
            md: `${theme.fonts.size.xxl}`,
            lg: `${theme.fonts.size['4xl']}`,
          },
        })}
      `,

      description: css`
        color: ${theme.colors.commonColors.white};
        max-width: 680px;
        text-align: center;
        color: var(--desc-text-color);

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.md}`,
            lg: `${theme.fonts.size.xl}`,
          },
        })}
      `,

      headerSection: css`
        ${responsive.create({
          marginBottom: {
            default: theme.spacing.get(48),
            md: theme.spacing.get(56),
            lg: theme.spacing.get(80),
          },
        })}
      `,

      visionSection: css`
        ${responsive.create({
          maxWidth: {
            default: `288px`,
            md: `368px`,
            lg: `518px`,
          },
        })}
      `,

      contentContainer: css`
        max-width: 600px;
      `,

      visionTitle: css`
        color: var(--text-color);
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.lg}`,
            md: `${theme.fonts.size.xl}`,
            lg: `${theme.fonts.size['3xl']}`,
          },
          marginBottom: {
            default: theme.spacing.get(8),
            md: theme.spacing.get(12),
            lg: theme.spacing.get(16),
          },
        })}
      `,

      visionDescription: css`
        color: var(--desc-text-color);
        font-size: ${theme.fonts.size.xl};
        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.sm}`,
            md: `${theme.fonts.size.sm}`,
            lg: `${theme.fonts.size.xl}`,
          },
        })}
        max-width: 518px;
      `,

      quotes: css`
        position: relative;
        font-family: 'Georgia', serif;
        color: var(--quote-color);
        font-style: italic;
        --blockquote-size: 30px;
        --blockquote-text-color: var(--desc-text-color);
        &::before,
        &::after {
          color: #10928f;
          font-family: 'Georgia', serif;
        }

        ${
          isDesktop &&
          css`
            --blockquote-size: 50px;
          `
        }

        ${
          isTablet &&
          css`
            --blockquote-size: 30px;
          `
        }

        ${responsive.create({
          fontSize: {
            default: `${theme.fonts.size.xxl}`,
            md: `${theme.fonts.size.xl}`,
            lg: `${theme.fonts.size['3xl']}`,
          },
          marginTop: {
            default: `${theme.spacing.get(40)}`,
            md: `${theme.spacing.get(60)}`,
            lg: `${theme.spacing.get(80)}`,
          },
          maxWidth: {
            default: `288px`,
            md: `396px`,
            lg: `618px`,
          },
        })}
      `,

      /* IMAGE SIDE */
      imageContainer: css`
        flex: 1;
        display: flex;
        justify-content: flex-end;
        padding-right: 0;
        margin-right: -130px; /* pushes image to the edge */
      `,
    }),
    [theme],
  );
};
